import { pathSubscription } from 'nike-re-framejs';

export const channelStatus$$ = channelId => pathSubscription(['turboLive', 'channelStatus', channelId]);
export const channelStatuses$ = pathSubscription(['turboLive', 'channelStatus']);
